import { Injectable, signal, effect } from '@angular/core';

export enum Theme {
    Dark = 'dark',
    Light = 'light',
}

const STORAGE_KEY = 'theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    readonly theme = signal<Theme>(this.loadTheme());

    constructor() {
        effect(() => {
            const theme = this.theme();
            document.documentElement.setAttribute('data-theme', theme);
            localStorage.setItem(STORAGE_KEY, theme);
        });
    }

    toggle(): void {
        this.theme.update(theme => (theme === Theme.Dark ? Theme.Light : Theme.Dark));
    }

    private loadTheme(): Theme {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored === Theme.Light ? Theme.Light : Theme.Dark;
    }
}
